import { useState, useEffect } from 'react';
import { IS_CAPACITOR } from '../api/config';
import './IosAppBanner.css';

const DISMISS_KEY = 'ios-app-banner-dismissed';
const APP_STORE_URL = 'https://apps.apple.com/us/app/stellar-music-discovery/id6759639587';

function isIosDevice() {
  const ua = window.navigator.userAgent;
  const isIpad = /iPad/.test(ua) || (/Macintosh/.test(ua) && 'ontouchend' in document);
  return /iPhone|iPod/.test(ua) || isIpad;
}

export default function IosAppBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (IS_CAPACITOR) return;
    if (!isIosDevice()) return;
    if (localStorage.getItem(DISMISS_KEY) === '1') return;
    setVisible(true);
  }, []);

  if (!visible) return null;

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setVisible(false);
  };

  return (
    <div className="ios-app-banner" role="region" aria-label="iOS app promotion">
      <button
        className="ios-app-banner-close"
        onClick={handleDismiss}
        aria-label="Dismiss"
      >
        &times;
      </button>
      <img
        src="/logo192.png"
        alt=""
        className="ios-app-banner-icon"
        aria-hidden="true"
      />
      <div className="ios-app-banner-text">
        <div className="ios-app-banner-title">Stellar for iOS</div>
        <div className="ios-app-banner-subtitle">Get the app for the best experience</div>
      </div>
      <a
        className="ios-app-banner-cta"
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        Get
      </a>
    </div>
  );
}
